/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ContainerFindings {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return ContainerFindings.fixupPrototype; }

    static newInstance(model: Partial<ContainerFindings>): ContainerFindings {
        let obj = Object.assign(new ContainerFindings(), model);
        ContainerFindings.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ContainerFindings>): ContainerFindings {
        if (!model) return null;
        return ContainerFindings.newInstance(<ContainerFindings> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ContainerFindings) {
        if (!obj) return;

        models.ContainerFindings.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ContainerFindings): boolean {
        switch (obj.__type)
        {
            case "ContainerFindingsForDockle":
                Object.setPrototypeOf(obj, models.ContainerFindingsForDockle.prototype);
                break;
            case "ContainerFindingsForHadolint":
                Object.setPrototypeOf(obj, models.ContainerFindingsForHadolint.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof ContainerFindings)[] {
        return [
            models.ContainerFindingsForDockle,
            models.ContainerFindingsForHadolint,
        ];
    }

    fixupFields() {
        if (this.parser_status) {
            models.AppSecopsSbomVersionParserStatus.fixupPrototype(this.parser_status);
        }
    }

    /**
     * Format of the container security findings file (JSON or plain text)
     */
    file_format: models.ContainerFindingsFileFormat;

    /**
     * Unique identifier of the attachment containing the container security findings data
     */
    attachment_id: string;

    /**
     * Current parsing status for this specific container security tool
     */
    parser_status: models.AppSecopsSbomVersionParserStatus;

    /**
     * Name of the user who recently created the container findings
     */
    created_by: string;

    /**
     * Name of the user who recently updated the container findings
     */
    updated_by: string;

}
